
import "./checkout-submit-notification-v1"
import "./checkout-apple-pay-button-v1"
import { isElementVisibleOnViewport } from '@yggdrasil/Utils/general'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutSubmitButtonV1 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}



  onSubmit(element) {}

  mount() {
    this.storeButtonInitialHTML()

    this.getSubmitButton().addEventListener('click', (evt) => {
      evt.preventDefault()
      this.requestSubmit()
    })

    const checkoutElement = this.element.closest('.elCheckout')
    Checkout.store.state.listen((state) => {
      if (state === Checkout.StoreStates.INITIALIZED && !this.keydownListenerAttached) {
        this.keydownListenerAttached = true
        document.addEventListener('keydown', (evt) => {
          if (evt.isComposing || evt.keyCode === 229) return
          if (evt.keyCode === 13 && $(this.element).is(':visible')) {
            if (isElementVisibleOnViewport(checkoutElement, 20)) {
              this.element.focus()
              this.requestSubmit()
            }
          }
        })
      }
    })
  }

  // The single entry point for every submit trigger. The lock is taken
  // synchronously, before any await, so it covers the whole attempt -- the
  // validation, tokenization and nonce work that runs before the payment POST as
  // well as the POST itself. The Enter key comes through here too, since
  // `pointer-events: none` only stops pointer input.
  requestSubmit() {
    if (this.isSubmitLocked()) return
    this.lockSubmit()

    Promise.all(this.onSubmit(this.element) ?? []).finally(() => {
      // A gateway claims the button by moving it into its submitting state, and
      // owns unlocking it from then on. When nothing claimed it the
      // attempt bailed out before the payment POST -- a validation error, a
      // failed tokenization, a dismissed payment sheet -- and no other code path
      // will ever re-enable the button.
      if (!this.submitClaimed) this.unlockSubmit()
    })
  }

  isSubmitLocked() {
    return this.getSubmitButton().getAttribute('data-disabled') === 'true'
  }

  // aria-disabled rides along because the button is an anchor: `pointer-events: none`
  // takes it out of the pointer flow but says nothing to a screen reader.
  lockSubmit() {
    this.getSubmitButton().setAttribute('data-disabled', true)
    this.getSubmitButton().setAttribute('aria-disabled', true)
  }

  unlockSubmit() {
    this.getSubmitButton().setAttribute('data-disabled', false)
    this.getSubmitButton().removeAttribute('aria-disabled')
  }

  // Locks the button on behalf of a gateway. Also covers submits that never
  // touched this button -- express/wallet payments, the OTO one-click flow --
  // which would otherwise leave it live while a payment is running.
  claimSubmit() {
    this.submitClaimed = true
    this.lockSubmit()
  }

  getSubmitButton() {
    return this.element.querySelector('[href="#submit-checkout-form"]')
  }

  storeButtonInitialHTML() {
    const buttonMainText = this.element.querySelector('.elButtonMain .elButtonMainText')
    const buttonSubText = this.element.querySelector('.elButtonSub')

    this.buttonMainTextInitialHTML = buttonMainText.innerHTML
    this.buttonSubTextInitialHTML = buttonSubText.innerHTML
  }

  // The gateways' "back to idle" call, and so also the only thing that releases
  // the submit lock. Callers must not use it to refresh the label while a submit
  // is in flight.
  setButtonInitialHTML() {
    this.submitClaimed = false
    this.unlockSubmit()
    this.element.removeAttribute('data-loading')
    const buttonMain = this.element.querySelector('.elButtonMain')
    const buttonSub = this.element.querySelector('.elButtonSub')
    buttonMain.querySelector('.elButtonSpinner').style.removeProperty('display');

    const buttonMainText = buttonMain.querySelector('.elButtonMainText')
    buttonMainText.innerHTML = this.buttonMainTextInitialHTML
    buttonSub.innerHTML = this.buttonSubTextInitialHTML
  }

  setLoading() {
    this.element.setAttribute('data-loading', 'true')
  }

  setSubmittingText() {
    this.claimSubmit()
    this.element.removeAttribute('data-loading')
    const buttonMain = this.element.querySelector('.elButtonMain')
    const buttonSub = this.element.querySelector('.elButtonSub')

    buttonMain.querySelector('.elButtonSpinner').style.display = 'inline-block'

    const buttonMainText = buttonMain.querySelector('.elButtonMainText')
    buttonMainText.innerHTML = this.submittingText
    buttonSub.innerHTML = ''
  }

  update({text, subText}: {text: string, subText: string}) {
    this.element.removeAttribute('data-loading')

    const buttonMain = this.element.querySelector('.elButtonMain')
    const buttonSub = this.element.querySelector('.elButtonSub')

    const buttonMainText = buttonMain.querySelector('.elButtonMainText')
    buttonMainText.textContent = text
    buttonSub.textContent = subText
  }



}

registerComponent('CheckoutSubmitButton/V1', CheckoutSubmitButtonV1)
window["CheckoutSubmitButtonV1"] = CheckoutSubmitButtonV1

